exports = module.exports = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2RsU8dO0bj_uqILOftMtJ8{font-size:12px;font-weight:400;-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;width:inherit;-ms-flex-wrap:wrap;flex-wrap:wrap;-ms-flex-line-pack:center;align-content:center}html[dir] ._2RsU8dO0bj_uqILOftMtJ8{margin:6px}", ""]);
// Exports
exports.locals = {
	"feedbackContainer": "_2RsU8dO0bj_uqILOftMtJ8"
};